import React, { useEffect, useState } from 'react';
import { Card, CardActions, CardContent, Typography } from '@material-ui/core';
import { SimpleShowLayout, TextField } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { stylesWide } from '../utils';
import VirtualStationActions from './actions';
import dataProvider from '../dataProvider';
import Loader from '../loader/Loader';
import './VirtualStation.css';

const PromoterVirtualStation = ({ permissions, resource, ...props }) => {
    const [virtualStation, setVirtualStation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchVirtualStation = async () => {
            try {
                const result = await dataProvider('GET_LIST', resource, {
                    pagination: { page: 1, perPage: 10 }, // Запрашиваем несколько записей
                    sort: { field: 'id', order: 'ASC' },
                    filter: {} // При необходимости можно добавить фильтры
                });
                if (result.total) {
                    setVirtualStation(result.data[0]);
                } else {
                    setError('Отсутствует привязанная виртуальная станция');
                }
            } catch (err) {
                setError('Ошибка при получении данных: ' + err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchVirtualStation();
    }, []);

    if (loading) {
        return (
            <div className='loader-container'>
                <Loader />
            </div>
        );
    }

    if (error) {
        return (
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        {error}
                    </Typography>
                </CardContent>
            </Card>
        );
    }

    // Если виртуальная станция найдена, отображаем её с теми же полями, что и в ShowVirtualStation
    return (
            <SimpleShowLayout {...props} record={virtualStation} title="Виртуальная станция">
                <CardActions
                    submitOnEnter={false}
                    style={{ display: 'flex', 'flexDirection': 'row', 'justifyContent': 'space-between'}}
                >
                    <VirtualStationActions
                        record={virtualStation}
                        resource={resource}
                        permissions={permissions}
                    />
                </CardActions>
                <TextField
                    label="Id"
                    source="id"
                />
                <TextField
                    label="Sno"
                    source="sno"
                />
                <TextField
                    label="Short number"
                    source="holder_short_number"
                />
                <TextField
                    label="Status"
                    source="status"
                />
            </SimpleShowLayout>
    );
};

export default withStyles(stylesWide)(PromoterVirtualStation);
